import { render } from "./home.vue?vue&type=template&id=b060d09e&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=b060d09e&scoped=true&lang=css"

import exportComponent from "D:\\A-daima\\前端\\前台\\前台\\nonferrous_metals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b060d09e"]])

export default __exports__